/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.4",
  "gitBuildTime": "2026-09-29T15:43:12.573Z",
  "gitBuildVersion": "2.9.4",
  "gitCommitId": "7fc9e7c",
  "gitCommitIdFull": "7fc9e7c321222de77ec0f6180345fb4c5da4c626",
  "gitCommitTime": "2026-09-29T15:41:34.000Z",
  "version": "2.9.4-2026-09-29T15:41:34.000Z-(7fc9e7c)"
};
